class SlideActionsFriendList {

    constructor() {

        this._slideActionsData = new SlideActionsData();
        this._loadPartialsTemplates();

    }

    _loadPartialsTemplates() {

        Handlebars.registerPartial("slideActionsFriendList", $("#slideActionsFriendList").html());

    }

    _enableHandlers() {

        $("div.slide-actions-list-button").on("click.toggleSlideButton", this._onToggleSlideActionsList.bind(this));
        $("div.slide-actions-list").on("click.actionButton", "div.slide-action-button", this._onClickButton.bind(this));

    }

    _onToggleSlideActionsList(event) {

        event.preventDefault();
        event.stopPropagation();

        function _onAnimationEnd() {
            $actionsList.addClass("is-displaced");
        }

        const $this = $(event.currentTarget);
        const userWorldId = $this.data("user");
        const $friendItem = $(".friend-item[data-user=" + userWorldId + "]");
        const $actionsList = $(".slide-actions-list[data-user=" + userWorldId + "]");
        const $actionsListButton = $actionsList.find(".slide-action-button");
        const buttonWidth = $actionsListButton.width();

        if ($actionsList.hasClass("is-displaced")) {
            $actionsList.removeClass("is-displaced");
            $friendItem.animate({left: 0});
        } else {
            $friendItem.animate({left: -buttonWidth * $actionsListButton.length}, _onAnimationEnd);
        }

    }

    _onClickButton(event) {

        const $this = $(event.currentTarget);
        const userWorldId = $this.data("user");
        const action = $this.data("action");
        const friendsActions = this._slideActionsData.getFriendsActions();

        switch(action) {

            case friendsActions.FOLLOW_ACTION:
                const isFollowing = $this.data("following");
                this._followAction(userWorldId, isFollowing);
                break;

            case friendsActions.EMAIL_ACTION:
                const email = $this.data("email");
                this._emailAction(userWorldId, email);
                break;

            case friendsActions.CALL_ACTION:
                const phone = $this.data("phone");
                this._phoneAction(userWorldId, phone);
                break;

            case friendsActions.CHAT_ACTION:
                this._chatAction(userWorldId);
                break;

            case friendsActions.CHALLENGE_ACTION:
                this._challengeAction(userWorldId);
                break;

        }

    }

    _followAction(userWorldId, isFollowing) {

        function _onSuccess(response) {

            if (api.checkisValidResult(response)) {

                const $followLabel = $(".friend-item[data-user=" + userWorldId + "] span.friend-following");
                const $followButton = $("div.slide-action-button[data-user=" + userWorldId + "][data-action=follow]");

                if (isFollowing) {
                    $followButton.find("span.title").text(Translator.trans("TR_SEGUIR"));
                    $followButton.find("span.subtitle").text(parseInt($followButton.find("span.subtitle").text()) - 1);
                    $followButton.data("following", false);
                    $followLabel.hide();
                } else {
                    $followButton.find("span.title").text(Translator.trans("TR_SIGUIENDO"));
                    $followButton.find("span.subtitle").text(parseInt($followButton.find("span.subtitle").text()) + 1);
                    $followButton.data("following", true);
                    $followLabel.show();
                }

            }

        }

        if (isFollowing) {
            api.unfollowUser(userWorldId, _onSuccess, false);
        } else {
            api.followUser(userWorldId, _onSuccess, false);
        }

    }

    _emailAction(userWorldId, email) {
        window.open('mailto:' + email);
    }

    _phoneAction(userWorldId, phone) {
        window.open('tel:' + phone);
    }

    _chatAction(userWorldId) {

        function _filterRoomCondition(room) {
            return room.user && (room.user.user_world_id == userWorldId)
        }

        function _filterUserCondition(user) {
            return user.user_world_id == userWorldId
        }

        let roomToDraw = null;
        let user = null;

        if (world.profile_customization.show_opponent_profile && userWorldId) {

            roomToDraw = chatScreenController.individualRooms.rooms.filter(_filterRoomCondition)[0];

            if (!roomToDraw) {
                user = worldHomeController.friends.filter(_filterUserCondition)[0];
                roomToDraw = chatScreenController.chat.getNewEmptyRoom(user, chatScreenController.INDIVIDUAL_ROOM);
            }

            chatScreenController.drawIndividualChat(roomToDraw);

            const $documentationHeader = $("#documentation-full-screen-header")
            const $closeChatroomButton = $("div.top-chat-info-back-btn");

            if (documentationScreenController.currentDocumentDetails) {

                $documentationHeader.hide();

                $closeChatroomButton.one("click.closeChatRoom", function() {
                    $documentationHeader.show()
                });

            }

        }

    }

    _challengeAction(userWorldId) {
        worldHomeController.onClickUserChallenge(userWorldId);
    }

    initialize() {
        this._enableHandlers();
    }

}